<!--店铺管理-->
<template>
  <div  class="app-container">
    <!--查询条件区域-->
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="120px">
          <el-form-item label="店长手机号:">
            <el-input v-model="queryParam.phone" placeholder="输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="店长姓名:">
            <el-input v-model="queryParam.name" placeholder="输入姓名"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>

    <div class="title-container" shadow="never" style="margin-top: 10px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="primary" size="medium" class="operator-btn0" style="width: auto;" icon="el-icon-circle-plus-outline" @click="handleCreateOne()">添加店铺管理员账号</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table ref="tableData"
                style="width: 100%"
                :data="tableData"
                v-loading="listLoading" border
                highlight-current-row
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="80"></el-table-column>
        <el-table-column prop="name" label="管理员姓名" ></el-table-column>
        <el-table-column prop="phone" label="管理员手机号" ></el-table-column>
        <el-table-column prop="loginAccount" label="管理员账号" ></el-table-column>
        <el-table-column prop="loginPasswd" label="密码" ></el-table-column>
        <el-table-column prop="createTime" label="账号创建时间" ></el-table-column>
        <el-table-column prop="lastLoginDate" label="上次登录时间" ></el-table-column>
        <el-table-column prop="validDate" label="到期时间" ></el-table-column>
        <el-table-column prop="shopFrontTitle" label="店铺名" ></el-table-column>
        <el-table-column prop="remark" label="备注" ></el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button @click.native.prevent="showChangeDlg(scope.$index, tableData)" type="warning" plain size="small">修改密码</el-button>
            <el-button @click.native.prevent="showDeleteDlg(scope.$index, tableData)" type="danger" plain size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>
    <el-dialog
      title="管理员信息"
      :visible.sync="visibleDlgInfo"
      width="50%"
      center>
      <div class="edit-area">
        <el-form label-width="150px">
          <el-form-item label="管理员姓名:">
            <el-input v-model="adminInfo.name" placeholder="输入管理员姓名" style="width: 300px;"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgInfo = false">取消</el-button>
        <el-button type="primary" @click="visibleDlgInfo = false">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="删除负责人"
      :visible.sync="visibleDlgDelete"
      width="50%"
      center>
      <div class="edit-area">
        <el-form label-width="150px">
          <el-form-item label="负责人姓名:">
            <el-input v-model="deleteParam.name" :readonly="true" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="店铺名:">
            <el-input v-model="deleteParam.shopFrontTitle" :readonly="true" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="手机号:">
            <el-input v-model="deleteParam.phone" :readonly="true" style="width: 300px;"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgDelete = false">取消</el-button>
        <el-button type="primary" @click="handleDelAdmin()">确定删除</el-button>
      </span>
    </el-dialog>
    <!--    添加-->
    <el-dialog
      title="添加店铺管理员"
      :visible.sync="visibleDlg"
      width="50%"
      center>
      <store-admin-detail
        :detail-param="createParam"
        :create-type=2
        @onBtnOK="onBtnOK"
        @onStoreAdmin="onStoreAdmin"
        @onBtnCancel="onBtnCancel()"
      >

      </store-admin-detail>
    </el-dialog>
    <el-dialog
      title="修改账号密码"
      :visible.sync="visibleDlgChangePasswd"
      width="50%"
      center>
      <div class="edit-area">
        <el-form label-width="150px">
          <el-form-item label="管理员姓名:">
            <el-input v-model="changePasswdParam.name" :readonly="true" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="账号:">
            <el-input v-model="changePasswdParam.loginAccount" :readonly="true" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="新密码:">
            <el-input v-model="changePasswdParam.newPasswd" placeholder="输入新密码" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="确认密码:">
            <el-input v-model="changePasswdParam.confirmPasswd" placeholder="确认密码" style="width: 300px;"></el-input>
          </el-form-item>
          <!--<el-form-item label="短信验证码:">-->
            <!--<el-input v-model="changePasswdParam.changeVcc" placeholder="" style="width: 300px;"></el-input>-->
          <!--</el-form-item>-->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgChangePasswd = false">取消</el-button>
        <el-button type="primary" @click="handleChangePasswd() ">确定修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>

<script>
  import StoreAdminDetail from '../components/StoreAdminDetail'
  import commonUtils from "../../../utils/commonUtils";
  import {changeAdminPasswd, createNewStoreAdmin, delAdmin, fechListStoreAdmin} from "../../../api/superAdmin";
  import messageUtils from "../../../utils/messageUtils";
  import globaldata from "../../../utils/globaldata";
  import {addChildAdmin} from "../../../api/storeAdmin";
  export default {
    components: { StoreAdminDetail },
    data() {
      return {

        listLoading: false,
        //弹窗
        visibleDlg: false,
        visibleDlgAdd:false,
        visibleDlgInfo:false,
        visibleDlgChangePasswd:false,
        visibleDlgDelete:false,

        //发送短信
        timerSendCodeTip :'发送短信',

        //查询参数
        queryParam: {
          phone: null,     //输入手机号
          name: null,  //输入店长名
          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },


        multipleSelection: [], //选择的表单
        //表单结果
        tableData: [
        ],



        adminInfo :{
          name:"李二狗",
          phone: '152106846744',
          loginAccount : 'asda1234',
          createTime :'2012-06-08',
          lastLoginDate:'2012-06-16',
          createAdminId : '1001',
          createAdminName :'张三但',
          validDate: '2012-06-16',
          shopFrontId: '1025',
          shopFrontTitle : '中国最大烤鸭店',
          remarks: "备注信息"
        },

        //添加参数
        createParam :{

        },
        //修改账号密码
        changePasswdParam:{},

        //删除
        deleteParam :{
        },
        handleRemoveStorePicIndex :-1,


      }
    },
    mounted() {

    },
    created() {
      this.flechList();
    },
    methods: {
      //点击查询按钮
      onBtnSearch(){
        this.flechList();
      },

      flechList(){
        this.listLoading = true;
        let param = {
          phone: this.queryParam.phone,     //输入手机号
          name:  this.queryParam.name,  //输入店长名
          pageNum : this.queryParam.pageNum ,//当前第几页
          pageSize :  this.queryParam.pageSize
        }
        fechListStoreAdmin(param).then(response =>
        {
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          this.queryParam.totalPage = date.total;
          this.refreshData(date.list);
          this.listLoading = false;
        })
      },

      //刷新页面数据
      refreshData(list){
        if (commonUtils.isObjectNull(list)){
          return;
        }
        this.tableData =list;

      },

      handleSelectionChange(val) {

      },

      onBtnOK(){
        this.visibleDlg = false;
        this.flechList();
      },

      onStoreAdmin(data){

        data.createAdminId = globaldata.getAdminStore().id;
        data.storeFrontId = 0;
        createNewStoreAdmin(data).then(response =>
        {
          messageUtils.successMsg(this,response.message)
          this.visibleDlg = false;
        })

      },

      onBtnCancel(){
        this.visibleDlg = false;
      },

      //添加一个
      handleCreateOne(){
        this.visibleDlg = true;
      },

      //详细信息
      onbtnGetInfo(index,tableData){

        this.visibleDlgInfo = this;
      },

      //修改密码
      showChangeDlg(index,tableData){
        this.visibleDlgChangePasswd = true;
        this.changePasswdParam = {
          id: tableData[index].id,
          name:tableData[index].name,
          phone:tableData[index].phone,
          loginAccount:tableData[index].loginAccount,
          newPasswd:"",
          confirmPasswd:"",
          changeVcc :''
        }
      },
      //修改密码
      handleChangePasswd(){
        this.checkChangValied(this.callCheckChangValied);
      },

      callCheckChangValied(msg,ok){
        if (ok ==false){
          this.$message({
            message: msg,
            type: 'warning'
          });
          return;
        }
        let changeParam = {
          id: this.changePasswdParam.id,
          passwd:this.changePasswdParam.newPasswd,
          confirmPasswd:this.changePasswdParam.confirmPasswd,
          vccCode:""
        };
        changeAdminPasswd(changeParam).then(response =>
        {
          if (response.data == true){
            messageUtils.successMsg(this,"修改成功");
            this.visibleDlgChangePasswd = false;
          }else {
            messageUtils.errorMsg(this,"修改失败");
          }
        })

      },

      checkChangValied(callback ){
        let errorMsg;
        let ok = false;
        if (commonUtils.isStringNull(this.changePasswdParam.newPasswd)
          ||commonUtils.isStringNull(this.changePasswdParam.confirmPasswd)
        ){
          errorMsg = "密码不一致或格式错误";
          if (callback){
            callback(errorMsg,ok);
          }
          return;
        }

        if (commonUtils.isStringNull(this.changePasswdParam.vccCode)
        ){
          // errorMsg = "请输入验证码";
          // if (callback){
          //   callback(errorMsg,ok);
          // }
          // return;
        }
        callback("",true);
      },

      //修改备注
      onbtnChangeRemark(index,tableData){
        this.$message('选择了 : ' + index);
      },
      //删除
      showDeleteDlg(index,tableData){
       this.visibleDlgDelete =true;
       this.deleteParam = {
         id: tableData[index].id,
         name:tableData[index].name,
         phone:tableData[index].phone,
         shopFrontTitle : tableData[index].shopFrontTitle,
       }
      },
      handleDelAdmin(){
        if (!commonUtils.isStringNull(this.deleteParam.shopFrontTitle)
        ){
          messageUtils.errorMsg(this,"已经绑定门店，不能删除")
          return
        }
        let param = {
          id: this.deleteParam.id,
          adminId: globaldata.getAdminStore().id
        }
        delAdmin(param).then(response =>
        {
          if (response.data == true){
            messageUtils.successMsg(this,"删除成功")
            this.visibleDlgDelete = false
            this.queryParam.pageNum = 1
            this.flechList()
          }else {
            messageUtils.successMsg(this,"删除失败")
          }
        })

      },

      handleSendCreateVcc(){
        this.createParam.vccCode = "135445";
      },
      handleSendChangePasswdVcc(){
        this.changePasswdParam.changeVcc = "135445";
      },

      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.flechList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
        this.flechList();
      },

    }
  }
</script>






// WEBPACK FOOTER //
// src/views/superadmin/store-admin/index.vue